var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#221f1f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m386.57 275.63a24.1 24.1 0 1 0 24.09 24.09 24.12 24.12 0 0 0 -24.09-24.09zm0 32a7.9 7.9 0 1 1 7.9-7.9 7.91 7.91 0 0 1 -7.9 7.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.37 221.59-83.92-8.44-17.86-29.7a57.16 57.16 0 0 0 -48.76-27.6h-81.07a49.3 49.3 0 0 0 -44.25 27.84l-14 29h-60.73a8.1 8.1 0 0 0 -8.1 8.1v41.42a45.65 45.65 0 0 0 45.61 45.6h2.1a47.93 47.93 0 0 0 94.54 0h127.37a47.93 47.93 0 0 0 94.54 0h25.71a8.1 8.1 0 0 0 8.1-8.1v-34.71a43.49 43.49 0 0 0 -39.28-43.41zm-261.26-30.89a33 33 0 0 1 29.65-18.65h81.07a40.86 40.86 0 0 1 34.87 19.74l12.58 20.91h-168.76zm-2.45 140.92a31.9 31.9 0 1 1 31.89-31.9 31.92 31.92 0 0 1 -31.89 31.9zm221.91 0a31.9 31.9 0 1 1 31.89-31.9 31.92 31.92 0 0 1 -31.89 31.9zm64.88-40h-17.61a47.93 47.93 0 0 0 -94.54 0h-127.37a47.93 47.93 0 0 0 -94.54 0h-2.1a29.44 29.44 0 0 1 -29.41-29.4v-33.32h253.39l87.48 8.8a27.37 27.37 0 0 1 24.7 27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.66 275.63a24.1 24.1 0 1 0 24.09 24.09 24.12 24.12 0 0 0 -24.09-24.09zm0 32a7.9 7.9 0 1 1 7.89-7.9 7.91 7.91 0 0 1 -7.89 7.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481 22.94h-77.82a8.1 8.1 0 1 0 0 16.19h69.69v69.69a8.1 8.1 0 1 0 16.19 0v-77.82a8.09 8.09 0 0 0 -8.06-8.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.8 472.87h-69.67v-69.67a8.1 8.1 0 1 0 -16.19 0v77.8a8.09 8.09 0 0 0 8.06 8.06h77.8a8.1 8.1 0 1 0 0-16.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.45 83.05h54.55v54.5a8.1 8.1 0 1 0 16.2 0v-62.55a8.09 8.09 0 0 0 -8.1-8.1h-62.6a8.1 8.1 0 1 0 0 16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.53 429h-54.48v-54.5a8.1 8.1 0 1 0 -16.2 0v62.6a8.09 8.09 0 0 0 8.1 8.1h62.58a8.1 8.1 0 0 0 0-16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75 145.65a8.1 8.1 0 0 0 8.1-8.1v-54.5h54.5a8.1 8.1 0 0 0 0-16.2h-62.6a8.09 8.09 0 0 0 -8.1 8.1v62.6a8.1 8.1 0 0 0 8.1 8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.05 366.35a8.1 8.1 0 0 0 -8.1 8.1v54.55h-54.48a8.1 8.1 0 0 0 0 16.2h62.58a8.09 8.09 0 0 0 8.1-8.1v-62.6a8.1 8.1 0 0 0 -8.1-8.15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCar);
export default __webpack_public_path__ + "static/media/ViewCar.4bc2a034f220da424352736d6e1e1e49.svg";
export { ForwardRef as ReactComponent };